import * as React from "react";
import {AnnotationManager} from "./AnnotationManager";
import {CSSProperties} from "react";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faArrowsAlt} from "@fortawesome/free-solid-svg-icons/faArrowsAlt";
import './AnnotationDiv.css';
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {DeleteDialog} from "shared/controls/Dialogs/premade/DeleteDialog";
import {AnnotationResizers} from "./AnnotationResizers";

export class AnnotationDiv extends React.Component<AnnotationDivProps, AnnotationDivState> {
    static defaultProps: Partial<AnnotationDivProps> = {};
    public Div:HTMLDivElement;
    public DeltaX:number;
    public DeltaY:number;

    public PositionOverwritten:boolean;
    constructor(props: AnnotationDivProps) {
        super(props);
        this.state = {};
        this.DivRendered=this.DivRendered.bind(this);
        this.DragMove=this.DragMove.bind(this);
        this.DragEnd=this.DragEnd.bind(this);
        this.PositionOverwritten=false;
    }

    public DivRendered(node){
        this.Div=node;
    }

    componentDidMount() {
        this.props.AnnotationManager.OnRefresh.Subscribe(this,()=>this.forceUpdate());

    }

    componentWillUnmount() {
        this.props.AnnotationManager.OnRefresh.Unsubscribe(this);
    }

    public render() {
        let isSelected=this.props.AnnotationManager.Page.DocumentManager.SelectedPDFField==this.props.AnnotationManager;
        let cords=this.props.AnnotationManager.GetDimension();
        if(this.PositionOverwritten&&this.Div!=null)
        {
            this.Div.style.left=cords.Left+'px';
            this.Div.style.top=cords.Top+'px';
            this.PositionOverwritten=false;
        }
        let fieldhasMapping=this.props.AnnotationManager.GetFieldSettings().MappedTo!='';

        let styles:CSSProperties={};
        styles.border='1px dashed red';
        if(isSelected)
        {
            styles.backgroundColor='rgba(255,0,0,.5)';

        }else{
            if(fieldhasMapping)
                styles.backgroundColor='rgba(144,238,144,.5)';
            else
                styles.backgroundColor='rgba(223,223,223,.5)'
        }


        return (
            <div ref={this.DivRendered} data-object-number={this.props.AnnotationManager.Id} className={this.props.AnnotationManager.Field?.getName()+ ' annotationDiv '+ (isSelected?'selected':'')} onClick={()=>this.props.AnnotationManager.Click()} key={this.props.AnnotationManager.AnotationObject.fieldName}
                 style={{position:'absolute',left:cords.Left,top:cords.Top,width:cords.Width,height:cords.Height,cursor:'pointer',...styles,boxSizing:'border-box'}}>
                <div style={{position:'absolute',left:5,top:-21}} className={'annotationToolbar'}>
                    <div className={'aicon'} onMouseDown={e=>this.DragStart(e)} draggable={false} onClick={e=>e.stopPropagation()}>
                        <FontAwesomeIcon icon={faArrowsAlt}/>
                    </div>
                    <div className={'aicon'} style={{marginLeft:2}} onClick={()=>this.MaybeRemove()} >
                        <FontAwesomeIcon icon={faTrash}/>
                    </div>
                </div>
                <AnnotationResizers  AnnotationDiv={this}/>
            </div>
        )
    }


    private async MaybeRemove() {
        if(await DeleteDialog.Show(''))
            this.props.AnnotationManager.Remove();
    }

    private DragStart(e:React.MouseEvent) {
        if(this.Div==null)
            return;
        e.preventDefault();

        e.stopPropagation();
        let bounds=this.props.AnnotationManager.Page.DocumentManager.Canvas.getBoundingClientRect();


        this.DeltaX=e.pageX-this.Div.getBoundingClientRect().x+window.scrollX;
        this.DeltaY=e.pageY-this.Div.getBoundingClientRect().y+window.scrollY;

        document.addEventListener("mousemove", this.DragMove);
        document.addEventListener("mouseup", this.DragEnd);



    }

    public DragMove(e:MouseEvent){
        this.PositionOverwritten=true;
        let bounds=this.props.AnnotationManager.Page.DocumentManager.Canvas.getBoundingClientRect();

        this.Div.style.left=(e.pageX-bounds.x-this.DeltaX)+'px';
        this.Div.style.top=(e.pageY-bounds.y-this.DeltaY)+'px';
    }

    public DragEnd(e:MouseEvent)
    {
        document.removeEventListener("mousemove", this.DragMove);
        document.removeEventListener("mouseup", this.DragEnd);


        this.props.AnnotationManager.MoveTo(parseFloat(this.Div.style.left),parseFloat(this.Div.style.top));


    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface AnnotationDivProps {
    AnnotationManager:AnnotationManager;
}

interface AnnotationDivState {

}

//#endregion "My Region"